import { render } from "./App.vue?vue&type=template&id=3d795a20"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3d795a20&lang=scss"

import exportComponent from "E:\\Projets\\Vue\\flashcard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__